// extracted by mini-css-extract-plugin
module.exports = {"Link":"CallOnPhone__Link_1vzgk"};